module.exports = __webpack_public_path__ + "static/img/3610_phase_function_Paper_Points.6ea5f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3610_phase_function_Paper_Points.png
// module id = Q9Ay
// module chunks = 0